export default __webpack_public_path__ + "static/media/paypal.08d5ac94.svg";